import { mockData } from './Mock';
import { Seller } from '../../models/Seller';

const mockSellers: Seller[] = [
    {
        id: 'S001',
        nickname: '专业咨询师小王',
        realName: '王小明',
        phone: '13800138001',
        status: 'active',
        isSuperIndividual: 1,
        requiredDeposit: 10000,
        actualDeposit: 10000,
        consultCount: 150,
        dealCustomerCount: 45,
        orderCount: 60,
        netConversionRate: 0.3,
        grossConversionRate: 0.4,
        level: 5,
        creditLevel: 4,
        creditLevelDesc: '极好',
        wechat: 'wxid_001',
        douyin: 'dy_001',
        isVerified: true,
        signatureImage: 'https://example.com/signature1.png',
        unwithdrawAmount: 5000,
        blacklistRecords: [],
        registerTime: Date.now() - 90 * 24 * 60 * 60 * 1000
    },
    {
        id: 'S002',
        nickname: '企业咨询顾问',
        realName: '李企业',
        phone: '13900139001',
        status: 'active',
        isSuperIndividual: 0,
        requiredDeposit: 50000,
        actualDeposit: 25000,
        consultCount: 300,
        dealCustomerCount: 100,
        orderCount: 120,
        netConversionRate: 0.33,
        grossConversionRate: 0.4,
        level: 4,
        creditLevel: 3,
        creditLevelDesc: '优秀',
        wechat: 'wxid_002',
        douyin: 'dy_002',
        isVerified: true,
        signatureImage: '',
        unwithdrawAmount: 15000,
        blacklistRecords: [
            { type: 0, reason: '违规操作', timestamp: Date.now() - 30 * 24 * 60 * 60 * 1000 },
            { type: 1, reason: '整改完成', timestamp: Date.now() - 15 * 24 * 60 * 60 * 1000 },
            { type: 0, reason: '违规操作', timestamp: Date.now() - 30 * 24 * 60 * 60 * 1000 },
            { type: 1, reason: '整改完成', timestamp: Date.now() - 15 * 24 * 60 * 60 * 1000 },
        ],
        registerTime: Date.now() - 180 * 24 * 60 * 60 * 1000
    }
];

// 仅注册静态数组，遵循 orderMock.ts 的用法
mockData.set('getSellerList', mockSellers); 